import { render, staticRenderFns } from "./modal_atender.vue?vue&type=template&id=38ec6f06"
import script from "./modal_atender.vue?vue&type=script&lang=js"
export * from "./modal_atender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports